export const Olive = () => {
    return (
        <>
          <h1>olive</h1>
        </>
    )
}